import React from "react";
import Button from "../../../common/button/button.js";
import { MEASURES, MEASURE_LABELS } from "../aabiConstants";

// D2: both revenue measures are always in the response; the toggle is pure
// client state — switching never triggers a new fetch (§2.2). Uses the same
// timeframe-button switcher convention as every other tab control on the page.
const MeasureToggle = ({ measure, onChange }) => (
  <>
    {Object.values(MEASURES).map((value) => (
      <Button
        key={value}
        variant="timeframe"
        isActive={measure === value}
        onClick={() => onChange(value)}
      >
        {MEASURE_LABELS[value]}
      </Button>
    ))}
  </>
);

export default MeasureToggle;
